/**
 * useTokenService - Vue composable for token management
 * Provides reactive token state and methods to update it
 */

import { ref } from 'vue';
import { tokenService } from '@/services/token.service';

export const useTokenService = () => {
  // Initialize with current token from storage
  const token = ref<string | null>(tokenService.getToken());

  /**
   * Set the token with optional persistence
   * @param newToken - The token to set
   * @param stayLoggedIn - If true, persist across browser sessions (localStorage)
   */
  const setToken = (newToken: string, stayLoggedIn: boolean = false): void => {
    tokenService.setToken(newToken, stayLoggedIn);
    token.value = newToken;
  };

  /**
   * Get the current token
   */
  const getToken = (): string | null => {
    return token.value;
  };

  /**
   * Clear the token
   */
  const clearToken = (): void => {
    tokenService.clearToken();
    token.value = null;
  };

  /**
   * Check if token exists
   */
  const hasToken = (): boolean => {
    return token.value !== null;
  };

  return {
    token,
    setToken,
    getToken,
    clearToken,
    hasToken,
  };
};
